import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiCallingService } from '../../../shared/services/api-calling.service';
import { ConfigApi } from '../../../config-api';
import { Globals } from '../../../shared/global';
import { environment } from '../../../../environments/environment';
import moment from 'moment';
import { ShareDataService } from '../../../shared/services/share-data.service';
import { KeycloakService } from 'keycloak-angular';
import { VersionDisplayServiceTsService } from '../../../../assets/version-services/version-display.service.ts.service';
import { BehaviorSubject } from 'rxjs';

export const sharedBroadcast = new BroadcastChannel('');
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  username: string = '';
  password: string = '';
  captcha!: string;
  loginForm!: FormGroup;
  captchaString: string = '';
  captchasum = { a: 0, b: 0, question: '', answer: 0 };
  visible: boolean = false;
  isLoginLoading = false;
  // version = environment.version;
  readonly version$ = this.displayVersion.version$;
  dateyear = moment().year();

  successResponse = {};

  otherDeviceResponse = {};

  invalidResponse = {};
  toEmail: string = 'org-af-fds-user@julius-berger.com';

  constructor(
    private http: HttpClient,
    private router: Router,
    private messageService: MessageService,
    private apiCallingService: ApiCallingService,
    private sharedService: ShareDataService,
    private globals: Globals,
    private keycloak: KeycloakService,
    private displayVersion: VersionDisplayServiceTsService
  ) {
    const currentRoute = this.router.url;
    if (
      (currentRoute === '/' || currentRoute === '/login') &&
      localStorage.getItem('isUserLogged') === 'true'
    ) {
      const userInfo = this.globals.getUserInfo();
      this.router.navigate(['/' + userInfo.defaultPage]);
    }

    sharedBroadcast.onmessage = (message) => {
      if (message.data === 'login') {
        window.location.reload();
      }
    };
  }

  ngOnInit(): void {
    this.generateCaptcha();

    this.version$.subscribe(v => console.log('current version:', v));
  }

  async loginWithKeycloak() {
    try {
      console.log('loginWithKeycloak');
      const authenticated = await this.keycloak.init({
        config: {
          url: 'https://jbnsabvjoeapp.j-b.group/',
          realm: 'fds',
          clientId: 'fds-client',
        },
        initOptions: {
          onLoad: 'login-required', // redirect to Keycloak login
          checkLoginIframe: false,
        },
        enableBearerInterceptor: true,
      });

      if (authenticated) {
        console.log('✅ Keycloak authenticated');

        // Get tokens
        const token = await this.keycloak.getToken();
        const refreshToken: any =
          this.keycloak.getKeycloakInstance().refreshToken;
        console.log('Access Token:', token);
        console.log('Refresh Token:', refreshToken);

        // Store token in localStorage (optional, for persistence)
        localStorage.setItem('kc_token', token);
        localStorage.setItem('kc_refreshToken', refreshToken);

        // 👉 Call your custom login API
        // Example with HttpClient
      } else {
        console.warn('❌ Keycloak authentication failed');
      }
    } catch (error) {
      console.error('Keycloak init error:', error);
    }
  }

  openMailClient() {
    // const subject = '';
    // const body = '';
    const mailtoLink = `mailto:${this.toEmail}`;

    window.location.href = mailtoLink;
  }

  generateCaptcha(): void {
    this.captchasum.a = Math.floor(Math.random() * 10) + 1;
    this.captchasum.b = Math.floor(Math.random() * 10) + 1;
    this.captchasum.answer = this.captchasum.a + this.captchasum.b;
    this.captchasum.question = `${this.captchasum.a} + ${this.captchasum.b}`;
  }

  // generateCaptcha(): void {
  //   this.loginForm?.get('captcha')?.setValue('');
  //   const possibleChars =
  //     'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  //   const length = 6;
  //   let captcha = '';
  //   for (let i = 0; i < length; i++) {
  //     captcha += possibleChars.charAt(
  //       Math.floor(Math.random() * possibleChars.length)
  //     );
  //   }
  //   this.captchaString = captcha;
  // }

  check(loginForm?: any, loginWith: string = 'Direct'): void {
    const ignoreCaptcha = JSON.parse(localStorage.getItem('ignoreCaptcha')!);
    if (loginForm?.valid || ignoreCaptcha === 1) {
      const payload = {
        userName:
          ignoreCaptcha === 1
            ? btoa(this.username)
            : btoa(loginForm.value.username),
        password:
          ignoreCaptcha === 1
            ? btoa(this.password)
            : btoa(loginForm.value.password),
        loginType: 'Web',
        loginWith: loginWith,
        deviceId: '',
      };

      // Check if ignoreCaptcha is 0 before validating the captcha
      if (
        (ignoreCaptcha === 0 || ignoreCaptcha == null) &&
        // loginForm.value.captcha !== this.captchaString
        loginForm.value.captcha != this.captchasum.answer
      ) {
        this.generateCaptcha();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Invalid Captcha',
        });
        this.captcha = '';
        return;
      }
      this.isLoginLoading = true;
      // this.router.navigate(['dashboard']);
      // const encryptedData = localStorage.getItem('Auth-user');
      this.apiCallingService
        .callAPI(payload, 'POST', ConfigApi.URLS.LOGIN)
        .subscribe({
          next: (response: any) => {
            response = JSON.parse(response);
            if (response?.responseCode === 200) {
              localStorage.clear();
              const now = new Date();
              const loginUtc = this.toUTCUsingExistingFn(now);
              localStorage.setItem('loginDateTime', loginUtc);
              this.successResponse = response.data[0];
              // localStorage.setItem('Auth-user', response?.data[0]?.TokenKey);

              let localData = {
                side_menu: response.data[0].sideMenu,
                user_info: response.data[0],
              };
              localStorage.setItem(
                'Auth_token',
                JSON.stringify(response.data[0].tokenKey)
              );
              localStorage.setItem('isUserLogged', 'true');
              localStorage.setItem('isExistingFavSite', JSON.stringify(0));
              localStorage.setItem('Auth-user', JSON.stringify(localData));
              localStorage.setItem('ignoreCaptcha', JSON.stringify(0));
              // localStorage.setItem('ApiFavSites', JSON.stringify(response?.data[0]?.favouriteSiteId));
              this.router.navigate([atob(response?.data[0].defaultPage)]);
              this.messageService.add({
                severity: 'success',
                summary: 'Success',
                detail:
                  response?.responseMessage.charAt(0).toUpperCase() +
                  response?.responseMessage.slice(1).toLowerCase(),
              });
              sharedBroadcast.postMessage('login');
              const userInfo = this.globals.getUserInfo();
              if (userInfo) {
                this.router.navigate(['/' + userInfo.defaultPage]);
              }
              setTimeout(() => loginForm?.reset(), 5 * 1000);
              this.sharedService.resetLogoutFlag();
            } else if (response.responseCode === 203) {
              this.otherDeviceResponse = response.responseMessage;
              let localData = {
                user_info: response.data[0],
              };
              // Store userData in localStorage
              localStorage.setItem('Auth_token', response?.data[0]?.tokenKey);

              localStorage.setItem('Auth-user', JSON.stringify(localData));

              localStorage.setItem('loginPayload', JSON.stringify(payload));
              localStorage.setItem('ignoreCaptcha', JSON.stringify(1));
              this.visible = true;
            }
            this.generateCaptcha();
          },

          error: (response) => {
            this.isLoginLoading = false;
            response = JSON.parse(response.error);
            loginForm.reset();
            this.generateCaptcha();
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail:
                response.responseMessage.charAt(0).toUpperCase() +
                response.responseMessage.slice(1).toLowerCase(),
            });
          },
          complete: () => {
            this.isLoginLoading = false;
          }
        });
    }
  }

  confirm() {
    const storedUserData = JSON.parse(localStorage.getItem('Auth-user')!);

    const userId = storedUserData.userId;
    this.apiCallingService
      .callAuthPostAPI({}, 'POST', ConfigApi.URLS.LOGOUT)
      .subscribe({
        next: (response: any) => {
          response = JSON.parse(response);
          if (response.responseCode == 200) {
            const loginpayload = localStorage.getItem('loginPayload');
            this.check();
          }
        },
      });
  }
  onCancel() {
    (this.username = ''), (this.password = ''), (this.captcha = '');
    localStorage.clear();
  }
  toUTCUsingExistingFn(dateInput: any): string {
    const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
    const corrected = new Date(d.getTime() - d.getTimezoneOffset() * 60000);
    return this.globals.convertLocalToUTC(corrected);
  }
}
